import ExpoAiLogo from 'pared/images/Expo/expoai.png'

import { IConfigsType } from '../../types'

const mwbHome: IConfigsType = {
  mwb: {
    '/:brand/scorecard': {
      groupFilter: {
        api: 'locationFilter',
      },
      title: {
        type: 'title',
        title: 'locationInfo',
        subTitle: 'storeSubtitle',
      },
      image: {
        type: 'image',
        src: ExpoAiLogo,
        alt: 'Expo AI',
        height: '40px',
      },
      exray: {
        type: 'ai-summary',
        fields: ['sales', 'labor', 'foodCost', 'guest', 'delivery'],
      },
      chatbox: {
        type: 'chatbox',
        hasSalesAnalysisButton: true,
      },
    },
  },
}

export default mwbHome
